import { createIconComponent } from '../../factory/create-icon-component';
export const LogoutIcon = createIconComponent(
  'LogoutIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.00012 12.0001L22.0001 12.0001M22.0001 12.0001L18.0001 8.00006M22.0001 12.0001L18.0001 16.0001"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.0001 16.0005L14.0001 16.5001C14.0001 17.896 14.0001 18.594 13.8278 19.162C13.4399 20.4401 12.4397 21.4404 11.1615 21.8282C10.5936 22.0005 9.89561 22.0005 8.49963 22.0005H8.00009C6.13635 22.0005 5.20449 22.0005 4.46941 21.6961C3.48928 21.2901 2.71057 20.5114 2.30459 19.5313C2.00012 18.7962 2.00012 17.8643 2.00012 16.0006L2.00012 8.00055C2.00012 6.13678 2.00012 5.2049 2.30461 4.46982C2.71058 3.4897 3.48928 2.71101 4.46939 2.30503C5.20448 2.00055 6.13636 2.00055 8.00012 2.00055L8.50061 2.00055C9.89572 2.00055 10.5933 2.00055 11.1609 2.17268C12.4396 2.56043 13.4402 3.56108 13.828 4.83978C14.0001 5.4074 14.0001 6.10495 14.0001 7.50006L14.0001 8.00055"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
